"use strict";function saveFile$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.saveFile$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.cspace.saveFile";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.7.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.7.6"},_a)),exports.saveFile$=saveFile$,exports.default=saveFile$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/cspace/saveFile.js
// module id = 941
// module chunks = 106